import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import {withTranslation, WithTranslation} from "react-i18next";

interface AboutProps extends WithTranslation {}

class About extends React.Component<AboutProps> {
    private changeLanguage = (language: string): void => {
        this.props.i18n.changeLanguage(language);
    };

    render(): JSX.Element {
        const { t } = this.props;
        return (
            <Box style={{padding: '60px 0', backgroundColor: "#fff"}}>
                <Container style={{textAlign: 'center'}} id="about">
                    <Typography variant="h3" gutterBottom style={{fontWeight: 'bold', color: '#0A74DA'}}>
                        {t('aboutUs')}
                    </Typography>
                    <Typography variant="body1" paragraph style={{color: '#555'}}>
                        {t('aboutUsDescription')}
                    </Typography>
                </Container>
            </Box>
        )
    };
}

export default withTranslation()(About);
